import type { AppCopy } from '../catalogs';

export const hrAppCopy = {
  welcomeHeading: 'Kako vam mogu pomoći danas?',
  thinking: 'Razmišljanje',
  scrollToBottom: 'Pomaknite se do dna',
  reasoning: 'Obrazloženje',
  reasoningInProgress: 'u tijeku',
  citationPages: 'Stranice {first}–{last}',
  citationTitle: 'Odlomak izvora',
  citationLoading: 'Učitavanje izvora…',
  citationUnavailable: 'Citirani tekst nije dostupan ili mu više nemate pristup.',
  citationOpen: 'Otvori izvor',
  citationCopied: 'Citat je kopiran',
  copy: 'Kopiraj',
  more: 'Više',
  tryAgain: 'Pokušajte ponovno',
  answerTruncated: 'Odgovor je dosegnuo ograničenje duljine i prekinut je.',
  continueAnswer: 'Nastavi odgovor',
  exportMarkdown: 'Izvezi kao Markdown',
  edit: 'Uredi',
  cancel: 'Odustani',
  update: 'Ažuriranje',
  previous: 'Prethodno',
  next: 'Dalje',
  messagePlaceholder: 'Pošaljite poruku…',
  projectHomePlaceholder: 'Novi chat: {project}',
  sharedChatEveryone: 'Svi u tvrtki {company} mogu čitati ovaj razgovor',
  sharedChatOnePerson: 'Ovaj razgovor može čitati 1 osoba',
  sharedChatPeople: 'Broj osoba koje mogu čitati ovaj razgovor: {count}',
  forkedChatPlaceholder: 'Nastavite sa svojim vezama…',
  newAnswer: 'Novi odgovor',
  messageInput: 'Unos poruke',
  sendMessage: 'Pošalji poruku',
  stopGenerating: 'Prestani generirati',
  addAttachment: 'Dodajte prilog',
  removeFile: 'Ukloni datoteku',
  attachmentPreview: 'Pregled privitaka',
  imageAttachmentPreview: 'Pregled privitka slike',
  image: 'Slika',
  openLink: 'otvori link',
  document: 'dokument',
  file: 'File',
  attachment: 'privitak',
  uploadFailed: 'učitavanje nije uspjelo',
  uploading: 'učitavanje',
  toolIncomplete: 'Nedovršeno',
  toolActivity: 'Aktivnost',
  activityThinking: 'Razmišlja…',
  activityWriting: 'Piše…',
  activityWaiting: 'Čeka vaše odobrenje',
  activityStopped: 'Zaustavljeno',
  activityCouldNotFinish: 'Nije moguće dovršiti',
  activitySources: 'izvora',
  activityShowThinking: 'Prikaži razmišljanje',
  activityOpen: 'Otvori aktivnost',
  activitySteps: 'Koraci',
  activitySourcesTab: 'Izvori',
  activityUnavailable: 'Ova aktivnost nije dostupna.',
  activityInput: 'Ulaz',
  activityOutput: 'Izlaz',
  activityNoSources: 'Ovaj odgovor nema citirane izvore.',
  activityApprovedByReply: 'Odobreno vašim odgovorom',

  toolRunning: 'U tijeku',
  toolComplete: 'Dovršeno',
  toolNeedsApproval: 'Potrebno odobrenje',
  toolInput: 'Unos',
  toolCall: 'poziv alata',
  toolCalls: 'pozive alata',
  openMenu: 'Otvori izbornik',
  closeMenu: 'Zatvori izbornik',
  close: 'Zatvori',
  showInTextField: 'Prikaži u tekstnom polju',
  settings: 'Postavke',
  appearance: 'Izgled',
  themeLight: 'Svijetla',
  themeDark: 'Tamna',
  themeSystem: 'Sustavna',
  themeChoiceHelp:
    'Primjenjuje se na svim vašim uređajima. „Sustavna” prati svijetli ili tamni način rada svakog uređaja.',
  themeSaveFailed: 'Izgled nije bilo moguće spremiti pa je ostao nepromijenjen. Pokušajte ponovno.',
  toolUsed: 'Korišten alat',
  toolCancelled: 'Otkazan alat',
  toolResult: 'rezultat:',
  toolError: 'Greška:',
  toolCancelledReason: 'Razlog otkazivanja:',
  approvalAllow: 'Dopusti',
  approvalAlwaysAllow: 'Uvijek dopusti',
  approvalDeny: 'Odbij',
  approvalAlwaysDeny: 'Uvijek odbij',
  approvalConfirm: 'Potvrdi',
  approvalBack: 'natrag',
  approvalApprovedResult: 'Odobrio korisnik',
  approvalDeniedResult: 'Korisnik je odbio izvršenje alata',
  logout: 'Odjavi se',
  loginOrCreateAccount: 'Prijavite se / Kreirajte račun',
  newChat: 'Novi chat',
  untitledChat: 'Chat bez naslova',
  previousChats: 'Prethodni razgovori',
  openChat: 'Otvorite chat {title}',
  moreActionsForChat: 'Više radnji za {title}',
  chatActions: 'Akcije chata',
  closeChatActions: 'Zatvori radnje chata',
  deleteChatQuestion: 'Izbrisati chat?',
  deleteChatDescription: 'Chat “{title}” bit će trajno izbrisan.',
  deleteChat: 'Izbriši chat',
  keepChat: 'Zadrži razgovor',
  delete: 'Izbriši',
  deleting: 'Brisanje...',
  chatDeleteFailed: 'Chat se nije mogao izbrisati. Pokušajte ponovno.',
  settingsDescription: 'Prilagodite način na koji pomoćnik radi za vas.',
  settingsDesktopDescription: 'Prilagodite kako vam pomoćnik odgovara.',
  personalization: 'Personalizacija',
  personalizationDescription: 'Prilagodite upute koje pomoćnik slijedi u svakom odgovoru.',
  languageAndRegion: 'Jezik i regija',
  languageAndRegionDescription: 'Odaberite jezik i vremensku zonu.',
  memories: 'Sjećanja',
  memoriesDescription: 'Pogledajte, uredite ili izbrišite ono što se pomoćnik sjeća o vama.',
  account: 'Račun',
  accountDescription: 'Upravljanje računom i trajno brisanje vaših podataka.',
  backToSettings: 'Povratak na postavke',
  closeSettings: 'Zatvori postavke',
  settingsCategories: 'Kategorije postavki',
  yourSettings: 'Vaše postavke',
  dataAndAccount: 'Podaci i račun',
  viewAndManageMemories: 'Pregledajte i upravljajte onim što pomoćnik pamti',
  loginToUseMemories: 'Prijavite se za korištenje uspomena',
  manageOrDeleteAccount: 'Upravljanje ili brisanje računa',
  unsavedChanges: 'Imate nespremljene promjene',
  unsavedCloseDescription: 'Zatvaranjem postavki odbacit ćete promjene na ovoj stranici.',
  unsavedBackDescription: 'Vraćanjem unatrag odbacit ćete promjene na ovoj stranici.',
  continueEditing: 'Nastavite s uređivanjem',
  discardChanges: 'Odbaci promjene',
  saveChanges: 'Spremite promjene',
  localSettingsNote: 'Spremljeno u ovom pregledniku. Prijavite se za spremanje na svoj račun.',
  personality: 'Osobnost',
  personalityHelp: 'Prilagođene upute koje pomoćnik slijedi u svakom odgovoru',
  personalityPlaceholder:
    'Na primjer: Budite sažeti i konkretni. Živim u Göteborgu i volim vegetarijansku hranu.',
  timezone: 'Vremenska zona',
  searchTimezone: 'Pretraživanje vremenskih zona…',
  automaticBrowser: 'Automatski (preglednik)',
  saved: 'Spremljeno {date}',
  addMemory: 'Dodaj uspomenu',
  newMemory: 'Nova uspomena',
  memoryPlaceholder: 'Na primjer: Preferiram kratke i konkretne odgovore.',
  editMemory: 'Uredi uspomenu',
  saveMemory: 'Spremi uspomenu',
  deleteMemory: 'Izbriši uspomenu',
  memorySaveFailed: 'Memorija se nije mogla spremiti. Pokušajte ponovno.',
  memoryLimitReached: 'Možete spremiti do 50 uspomena. Izbrišite jednu prije dodavanja nove.',
  memoryInvalid: 'Uspomene ne smiju sadržavati poveznice. Uklonite poveznicu i pokušajte ponovno.',
  memoryDeleteFailed: 'Memorija se nije mogla izbrisati. Pokušajte ponovno.',
  memoryLoadFailed: 'Sjećanja se ne mogu učitati.',
  loadingMemories: 'Učitavanje sjećanja…',
  emptyMemories:
    'Pomoćnik sprema uspomene o vama dok razgovarate — što volite, gdje živite i što radite. Ovdje ih možete pregledavati, uređivati ​​i brisati.',
  deleteAccountHelp: 'Trajno izbrišite račun i sve povezane razgovore, uspomene i postavke.',
  deleteAccount: 'Izbriši račun',
  deleteAccountQuestion: 'Trajno izbrisati račun?',
  deleteAccountDescription:
    'Izbrisat će se svi razgovori, poruke, sjećanja, postavke i vjerodajnice za prijavu. Ova se radnja ne može poništiti.',
  deleteAccountConfirm: 'Da, izbriši moj račun',
  accountDeleteFailed:
    'Račun nije bilo moguće izbrisati. Ništa nije uklonjeno — pokušajte ponovno.',
  logoutEverywhereTitle: 'Svi uređaji',
  logoutEverywhereHelp:
    'Odjavite se na svim uređajima i preglednicima na kojima je vaš račun otvoren, uključujući ovaj.',
  logoutEverywhere: 'Odjavi se svugdje',
  logoutEverywhereQuestion: 'Odjaviti se na svim uređajima?',
  logoutEverywhereDescription:
    'Morat ćete se ponovno prijaviti na svim uređajima i preglednicima, uključujući ovaj. Vaši razgovori i postavke ostaju nepromijenjeni.',
  loggingOut: 'Odjava u tijeku…',
  logoutEverywhereFailed:
    'Nismo mogli potvrditi da ste odjavljeni svugdje. Pokušajte ponovno ili na drugom uređaju provjerite jeste li još uvijek prijavljeni.',
  settingsSaveFailed: 'Postavke nije bilo moguće spremiti. Pokušajte ponovno.',
  customInstructions: 'Prilagođene upute',
  notSet: 'Nije postavljeno',
  automaticLanguage: 'Automatski jezik',
  automaticTimezone: 'automatska vremenska zona',
  appLanguage: 'Jezik aplikacije',
  appLanguageHelp:
    'Upravlja cijelim sučeljem aplikacije i datumima. Odgovori pomoćnika i dalje slijede jezik na kojem pišete.',
  automaticBrowserLanguage: 'Automatski (jezik preglednika)',
  previousLanguageChoice: 'Prethodni izbor: {language} ({locale})',
  previousLanguageChoiceCode: 'Prethodni izbor ({locale})',
  canvasCopyLink: 'Kopiraj poveznicu',
  canvasLinkCopied: 'Poveznica je kopirana',
  actionUpdatedWithEdits: 'Ažurirano vašim izmjenama',
  activityStepsDone: 'one:korak završen|few:koraka završena|other:koraka završeno',
  activityResultsCount: 'one:rezultat|few:rezultata|other:rezultata',
  canvasCopyLinkFailed: 'Poveznicu nije moguće kopirati',
  canvasOpenInAgent: 'Otvori u aplikaciji {agent}',
  canvasExpand: 'Proširi',
  canvasExitFullView: 'Izađi iz punog prikaza',
  webSourceUnread:
    'Povezano u ovom odgovoru. Poneva nije pročitala ovu stranicu pa ovdje nema što prikazati.',
  webSourceOpenOriginal: 'Otvori izvornik',
  toolProgressSettings: 'Mijenjam vaše postavke…',
  toolProgressAgent: 'Stvaram agenta…',
  toolProgressConnections: 'Tražim mogućnosti povezivanja…',
  toolProgressResult: 'Pripremam vaš rezultat…',
  toolProgressClarification: 'Pripremam pojašnjenje…',
  toolProgressKnowledge: 'Pripremam predloženo ažuriranje znanja…',
  toolProgressQuestion: 'Pripremam pitanje za vas…',
  toolProgressSkill: 'Oblikujemo vaš Skill…',
  toolErrorSettings: 'Vaše postavke nisu promijenjene.',
  toolErrorAgent: 'Agenta nije bilo moguće stvoriti.',
  toolErrorConnections: 'Mogućnosti povezivanja nije bilo moguće učitati.',
  toolErrorResult: 'Rezultat nije spremljen.',
  toolErrorClarification: 'Pojašnjenje nije bilo moguće pripremiti.',
  toolErrorKnowledge: 'Predloženo ažuriranje znanja nije bilo moguće pripremiti.',
  toolErrorQuestion: 'Pitanje nije bilo moguće pripremiti.',
  toolErrorSkill: 'Nacrt Skilla nije bilo moguće spremiti.',
  toolErrorOpenSettings: 'Otvori Postavke',
  toolErrorOpenAgents: 'Otvori Agente',
  toolErrorOpenConnections: 'Otvori Veze',
  toolStepIncomplete: 'Ovaj korak nije dovršen.',
  toolEarlierAttemptsFailed:
    'one:raniji pokušaj nije uspio|few:ranija pokušaja nisu uspjela|other:ranijih pokušaja nije uspjelo',
} satisfies AppCopy;
